var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    clipPath: "url(#clip0_174_12081)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.2742 2H2.14353C1.3783 2 0.759154 2.5625 0.759154 3.25L0.752197 10.75C0.752197 11.4375 1.3783 12 2.14353 12H13.2742C14.0394 12 14.6655 11.4375 14.6655 10.75V3.25C14.6655 2.5625 14.0394 2 13.2742 2ZM13.2742 4.5L7.70885 7.625L2.14353 4.5V3.25L7.70885 6.375L13.2742 3.25V4.5Z",
    fill: "#BEAEFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_174_12081"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.9133,
    height: 14,
    fill: "white",
    transform: "translate(0.752197)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.7496557215a16c0adf83fd195f6846d5.svg";
export { ForwardRef as ReactComponent };